import { GET } from "../../API/get";

export const fetchUndecidedRequests = async (page_number = 1, searchTerm = "") => {
    const response = await GET(`job/all/undecided/requests/${page_number}?search_term=${encodeURIComponent(searchTerm)}`);
    return response.status === "Success" ? response : null;
}